import { render, staticRenderFns } from "./LegalTextsEditor.vue?vue&type=template&id=a3c09d46&scoped=true"
import script from "./LegalTextsEditor.vue?vue&type=script&lang=js"
export * from "./LegalTextsEditor.vue?vue&type=script&lang=js"
import style0 from "./LegalTextsEditor.vue?vue&type=style&index=0&id=a3c09d46&prod&lang=scss&scoped=true"
import style1 from "./LegalTextsEditor.vue?vue&type=style&index=1&id=a3c09d46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c09d46",
  null
  
)

export default component.exports